import {eventLoader} from '@otto-ec/global-resources/event-loader';
import FeedbackStartPage from '@feedback/FeedbackStartPage.ts';

eventLoader.onAllScriptsExecuted(
    10,
    () => {
        FeedbackStartPage.initialize(document)
    }
);